export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/logo_design.39878c4.svg";